export default "#### Business use\n\nYou’re buying on behalf of a business\n";